import React, { useState, useCallback, useMemo } from 'react';
var AccordionContext =
/*#__PURE__*/
React.createContext({
  openItemKey: null,
  toggleOpenItem: function toggleOpenItem() {
    return void 0;
  }
});

var Accordion = function Accordion(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      openItemKey = _useState[0],
      setOpenItem = _useState[1];

  var toggleOpenItem = useCallback(function (key) {
    if (key === openItemKey) {
      setOpenItem(null);
      return;
    }

    setOpenItem(key);
  }, [openItemKey, setOpenItem]);
  var keyedChildren = useMemo(function () {
    return React.Children.map(children, function (child, index) {
      if (!
      /*#__PURE__*/
      React.isValidElement(child)) {
        return;
      }

      return (
        /*#__PURE__*/
        React.cloneElement(child, {
          itemKey: index
        })
      );
    });
  }, [children]);
  return (
    /* @__PURE__ */
    React.createElement(AccordionContext.Provider, {
      value: {
        openItemKey: openItemKey,
        toggleOpenItem: toggleOpenItem
      }
    }, keyedChildren)
  );
};

Accordion.displayName = "Accordion";
export { Accordion, AccordionContext };